import { defineMessages } from 'react-intl';

export default defineMessages({
    Drivers: {
        id: 'ml.quoteandbind.common.driversListComponent.Drivers',
        defaultMessage: 'Drivers'
    },
    BelowIsTheListOfYourDrivers: {
        id: 'ml.quoteandbind.common.driversListComponent.Below is the list of your drivers',
        defaultMessage: 'Below is the list of your drivers'
    },
    primaryVehicleQuestion: {
        id: 'ml.quoteandbind.common.driversListComponent.ml.quoteandbind.common.driversListComponent.Which vehicle do you primarily drive?',
        defaultMessage: 'ml.quoteandbind.common.driversListComponent.Which vehicle do you primarily drive?'
    },
    verifyOrUpdateInfo: {
        id: 'ml.quoteandbind.common.driversListComponent.Verify or update above information',
        defaultMessage: 'Verify or update above information'
    }
});
